var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imagemSRC !== null || _vm.imagemSRC == '')?_c('img',{attrs:{"src":_vm.imagemSRC}}):_c('img',{attrs:{"src":require("../../../../assets/icons/perfil-guest.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }